/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersIdGet200ResponsePersonalDetails model module.
 * @module model/CustomersIdGet200ResponsePersonalDetails
 * @version 1.0.0
 */
class CustomersIdGet200ResponsePersonalDetails {
    /**
     * Constructs a new <code>CustomersIdGet200ResponsePersonalDetails</code>.
     * @alias module:model/CustomersIdGet200ResponsePersonalDetails
     */
    constructor() { 
        
        CustomersIdGet200ResponsePersonalDetails.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomersIdGet200ResponsePersonalDetails</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersIdGet200ResponsePersonalDetails} obj Optional instance to populate.
     * @return {module:model/CustomersIdGet200ResponsePersonalDetails} The populated <code>CustomersIdGet200ResponsePersonalDetails</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersIdGet200ResponsePersonalDetails();

            if (data.hasOwnProperty('firstName')) {
                obj['firstName'] = ApiClient.convertToType(data['firstName'], 'String');
            }
            if (data.hasOwnProperty('lastName')) {
                obj['lastName'] = ApiClient.convertToType(data['lastName'], 'String');
            }
            if (data.hasOwnProperty('emailAddress')) {
                obj['emailAddress'] = ApiClient.convertToType(data['emailAddress'], 'String');
            }
            if (data.hasOwnProperty('dateOfBirth')) {
                obj['dateOfBirth'] = ApiClient.convertToType(data['dateOfBirth'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersIdGet200ResponsePersonalDetails</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersIdGet200ResponsePersonalDetails</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['firstName'] && !(typeof data['firstName'] === 'string' || data['firstName'] instanceof String)) {
            throw new Error("Expected the field `firstName` to be a primitive type in the JSON string but got " + data['firstName']);
        }
        // ensure the json data is a string
        if (data['lastName'] && !(typeof data['lastName'] === 'string' || data['lastName'] instanceof String)) {
            throw new Error("Expected the field `lastName` to be a primitive type in the JSON string but got " + data['lastName']);
        }
        // ensure the json data is a string
        if (data['emailAddress'] && !(typeof data['emailAddress'] === 'string' || data['emailAddress'] instanceof String)) {
            throw new Error("Expected the field `emailAddress` to be a primitive type in the JSON string but got " + data['emailAddress']);
        }
        // ensure the json data is a string
        if (data['dateOfBirth'] && !(typeof data['dateOfBirth'] === 'string' || data['dateOfBirth'] instanceof String)) {
            throw new Error("Expected the field `dateOfBirth` to be a primitive type in the JSON string but got " + data['dateOfBirth']);
        }

        return true;
    }


}



/**
 * @member {String} firstName
 */
CustomersIdGet200ResponsePersonalDetails.prototype['firstName'] = undefined;

/**
 * @member {String} lastName
 */
CustomersIdGet200ResponsePersonalDetails.prototype['lastName'] = undefined;

/**
 * @member {String} emailAddress
 */
CustomersIdGet200ResponsePersonalDetails.prototype['emailAddress'] = undefined;

/**
 * @member {String} dateOfBirth
 */
CustomersIdGet200ResponsePersonalDetails.prototype['dateOfBirth'] = undefined;






export default CustomersIdGet200ResponsePersonalDetails;

